import { render, staticRenderFns } from "./default.vue?vue&type=template&id=052dc37f&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavBar: require('D:/4team_web/FT.Web.Products/FT.Web.Templated/components/NavBar.vue').default,SvgRender: require('D:/4team_web/FT.Web.Products/FT.Web.Templated/components/SvgRender.vue').default,Layout: require('D:/4team_web/FT.Web.Products/FT.Web.Templated/components/Layout.vue').default,Dialog: require('D:/4team_web/FT.Web.Products/FT.Web.Templated/components/Dialog.vue').default,DiscountBanner: require('D:/4team_web/FT.Web.Products/FT.Web.Templated/components/DiscountBanner.vue').default,DiscountText: require('D:/4team_web/FT.Web.Products/FT.Web.Templated/components/DiscountText.vue').default,Stepper: require('D:/4team_web/FT.Web.Products/FT.Web.Templated/components/Stepper.vue').default,Link: require('D:/4team_web/FT.Web.Products/FT.Web.Templated/components/Link.vue').default,PaymentSection: require('D:/4team_web/FT.Web.Products/FT.Web.Templated/components/PaymentSection.vue').default,Footer: require('D:/4team_web/FT.Web.Products/FT.Web.Templated/components/Footer.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScrollXTransition } from 'vuetify/lib/components/transitions';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VApp,VBtn,VCard,VCol,VDivider,VExpandTransition,VIcon,VMain,VRow,VScrollXTransition,VSystemBar})
